import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import mail from '../../../assets/images/login/mail_send.png'
import { 
  MailIcon,
  Title, Subtitle, EmailText, Instruction, 
  ActionButton, Footer, FooterTitle, FooterDescription 
} from './styled'
import { ThreeCircles } from 'react-loader-spinner'

const RegisterSuccessful = ({ switchMailSent, mailValues, isSignUpMailSent, tick, setTick, isSending }) => {
  const { t } = useTranslation()
  const displayEmail = mailValues?.['email'] || t('common.emailExample')
  
  React.useEffect(() => {
    if (tick === 0) return

    const timer = setTimeout(() => {
      if (tick >= 0) setTick(prevTick => prevTick - 1)
    }, 1000);

    return () => clearTimeout(timer)

  }, [tick])

  const isTicking = tick > 0
  return (
    <div>
      <MailIcon src={mail} alt={t('getStarted.checkYourEmail')} />

      <Title>{t('getStarted.checkYourEmail')}</Title>
      <Subtitle>{t('getStarted.sentVerificationEmailTo')}</Subtitle>
      <EmailText>{displayEmail}</EmailText>
      <Instruction>{t('getStarted.openInboxAndClick')}</Instruction>
      <ActionButton type="button" onClick={switchMailSent} disabled={isTicking}>
        {
          (isSending) ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ThreeCircles height='20' width='20' color='white' ariaLabel='three-circles-loading' />
              </div>
            ) : (
            <>
              {t('getStarted.resendEmail')}&nbsp;
              { (isTicking) && <>
                {tick}{ (tick > 1) ? '(s)' : ''}
              </> }
            </>
          )
        }
      </ActionButton>

      <Footer>
        <FooterTitle>{t('getStarted.didntReceiveEmail')}</FooterTitle>
        <FooterDescription>{t('getStarted.checkSpamFolderOrResend')}</FooterDescription>
      </Footer>
    </div>
  )
}

export default RegisterSuccessful